import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Tooltip from '@material-ui/core/Tooltip';

const useStyles = makeStyles({
    menuButton: {
      color: '#000000',
        '&:hover': {
          color: '#63D764'
        }
    }
  });

  const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: '#f5f5f9',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #dadde9',
    },
  }))(Tooltip);

export default function MenuButton(props) {
  const classes = useStyles();

  const handleClick = () => {
    props.handleClick();
  };

  return (
    <HtmlTooltip title={<React.Fragment>{props.tooltip}</React.Fragment>}>
      <span >
        <Button className={classes.menuButton} disabled={props.disabled}  onClick={handleClick}>
              <Box p={1} fontWeight="fontWeightBold" fontSize={12}>{props.label}</Box>
        </Button>
      </span>
    </HtmlTooltip>
  );
}